export const categories = [
  "Books & Notes", "Electronics", "Food & Drinks", "Clothing", "Bags", "Furniture",
  "Sports & Fitness", "Stationery", "Appliances", "Games", "Other",
];

export const subcategoryMap = {
  Clothing: ["XS", "S", "M", "L", "XL", "XXL"],
  "Books & Notes": ["Notes", "Textbook", "Novel", "Magazine", "Other"],
  Electronics: ["Laptop", "Phone", "Tablet", "Headphones", "Camera", "Accessories", "Other"],
  Furniture: ["Chair", "Table", "Bed", "Shelf", "Sofa", "Other"],
  "Sports & Fitness": ["Cricket", "Football", "Basketball", "Gym Equipment", "Badminton", "Cycling", "Bottle/Flask", "Other"],
  Stationery: ["Notes", "Textbook", "Novel", "Art Supplies", "Geometry Box", "Other"],
  Appliances: ["Fan", "Fridge", "Microwave", "Washing Machine", "AC", "Heater", "Other"],
  Games: ["Board Game", "Video Game", "Puzzle", "Instrument", "Collectible", "Other"],
  "Food & Drinks": ["Homemade", "Packaged", "Beverages", "Snacks", "Other"],
  Bags: ["Backpack", "Laptop Bag", "Duffel Bag", "Messenger Bag", "Tote", "Travel Bag", "Wallet", "Other"],
  Other: [],
};

export function getSubcategories(category) {
  return subcategoryMap[category] || [];
}

export function getSubcategoryLabel(category) {
  return { Clothing: "Size", Electronics: "Type", Furniture: "Type", "Sports & Fitness": "Sport", Bags: "Type", "Books & Notes": "Type" }[category] || "Subcategory";
}

export const CATEGORY_EMOJI = {
  Electronics: "\uD83D\uDCBB", "Books & Notes": "\uD83D\uDCDA", Clothing: "\uD83D\uDC55", Furniture: "\uD83E\uDE91",
  "Food & Drinks": "\uD83C\uDF71", "Sports & Fitness": "\u26BD", Stationery: "\u270F\uFE0F",
  Appliances: "\uD83D\uDD0C", Games: "\uD83C\uDFAE", Bags: "\uD83C\uDF92", Other: "\uD83D\uDCE6",
};

export const sortOptions = [
  { value: "", label: "Newest" },
  { value: "desc", label: "Price \u2191" },
  { value: "asc", label: "Price \u2193" },
];

export const emptyFilters = {
  category: "", subcategory: "", sortPrice: "",
  condition: "", minPrice: "", maxPrice: "",
  statuses: ["available"], specs: {},
};

export const conditions = ["Like New", "Good", "Fair", "Poor"];

const _specFieldsMap = {
  Laptop: [
    { key: "brand", label: "Brand", placeholder: "e.g. Dell, Apple, Samsung", span: 1 },
    { key: "ram", label: "RAM", placeholder: "e.g. 8GB, 16GB", span: 1 },
    { key: "storage", label: "Storage", placeholder: "e.g. 256GB, 1TB", span: 1 },
    { key: "processor", label: "Processor", placeholder: "e.g. Intel i5, M2", span: 1 },
    { key: "display", label: "Display", placeholder: 'e.g. 15.6", 4K OLED', span: 2 },
  ],
  Phone: [
    { key: "brand", label: "Brand", placeholder: "e.g. Samsung, Apple, OnePlus", span: 1 },
    { key: "ram", label: "RAM", placeholder: "e.g. 6GB, 8GB, 12GB", span: 1 },
    { key: "storage", label: "Storage", placeholder: "e.g. 128GB, 256GB", span: 1 },
    { key: "battery", label: "Battery", placeholder: "e.g. 5000mAh", span: 1 },
    { key: "display", label: "Display", placeholder: 'e.g. 6.5", AMOLED', span: 2 },
  ],
  Tablet: [
    { key: "brand", label: "Brand", placeholder: "e.g. Apple, Samsung, Lenovo", span: 1 },
    { key: "ram", label: "RAM", placeholder: "e.g. 4GB, 8GB", span: 1 },
    { key: "storage", label: "Storage", placeholder: "e.g. 64GB, 256GB", span: 1 },
    { key: "display", label: "Display", placeholder: 'e.g. 10.9", Retina', span: 2 },
  ],
  Headphones: [
    { key: "brand", label: "Brand", placeholder: "e.g. Sony, JBL, Boat", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Over-ear, In-ear, Neckband", span: 1 },
    { key: "battery", label: "Battery", placeholder: "e.g. 20hrs, Wired", span: 2 },
  ],
  Camera: [
    { key: "brand", label: "Brand", placeholder: "e.g. Canon, Nikon, Sony", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. DSLR, Mirrorless, Point-and-shoot", span: 1 },
    { key: "megapixels", label: "Megapixels", placeholder: "e.g. 24MP, 45MP", span: 2 },
  ],
  "Electronics Accessories": [
    { key: "brand", label: "Brand", placeholder: "e.g. Portronics, Ambrane", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Case, Charger, Cable, Stand", span: 2 },
  ],

  Clothing: [
    { key: "gender", label: "Gender", placeholder: "e.g. Male, Female, Unisex", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Black, Navy Blue", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. T-shirt, Jeans", span: 2 },
  ],

  "1st Sem": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 2 }],
  "2nd Sem": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 2 }],
  "3rd Sem": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 2 }],
  "4th Sem": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 2 }],
  "5th Sem": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 2 }],
  "6th Sem": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 2 }],
  "7th Sem": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 2 }],
  "8th Sem": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 2 }],
  "1st Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Maths, English", span: 2 }],
  "2nd Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Maths, English", span: 2 }],
  "3rd Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Maths, English, EVS", span: 2 }],
  "4th Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Maths, English, Science", span: 2 }],
  "5th Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Maths, English, Science", span: 2 }],
  "6th Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Maths, Science, Social Studies", span: 2 }],
  "7th Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Maths, Science, Social Studies", span: 2 }],
  "8th Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Maths, Science, Social Studies", span: 2 }],
  "9th Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Chemistry, Maths", span: 2 }],
  "10th Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Chemistry, Maths", span: 2 }],
  "11th Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Chemistry, Maths", span: 2 }],
  "12th Class": [{ key: "subject", label: "Subject", placeholder: "e.g. Physics, Chemistry, Maths", span: 2 }],

  Chair: [
    { key: "material", label: "Material", placeholder: "e.g. Solid Wood, Metal, Plastic", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Brown, Black", span: 1 },
    { key: "dimensions", label: "Dimensions", placeholder: "e.g. 45 x 50 x 80 cm", span: 2 },
  ],
  Table: [
    { key: "material", label: "Material", placeholder: "e.g. Solid Wood, Glass, Metal", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Brown, White", span: 1 },
    { key: "dimensions", label: "Dimensions", placeholder: "e.g. 120 x 60 cm", span: 2 },
  ],
  Bed: [
    { key: "material", label: "Material", placeholder: "e.g. Solid Wood, Metal", span: 1 },
    { key: "size", label: "Size", placeholder: "e.g. Single, Double, Queen", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Brown, White", span: 2 },
  ],
  Shelf: [
    { key: "material", label: "Material", placeholder: "e.g. Wood, Metal, Plastic", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Brown, White, Black", span: 2 },
  ],
  Sofa: [
    { key: "material", label: "Material", placeholder: "e.g. Fabric, Leather, Velvet", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Grey, Blue, Beige", span: 1 },
    { key: "dimensions", label: "Dimensions", placeholder: "e.g. 3-Seater, L-Shaped", span: 2 },
  ],
  "Furniture Other": [
    { key: "material", label: "Material", placeholder: "e.g. Wood, Metal, Plastic", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Brown, White, Black", span: 2 },
  ],

  Cricket: [
    { key: "brand", label: "Brand", placeholder: "e.g. SG, MRF, SS", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Bat, Ball, Pad, Gloves", span: 1 },
    { key: "weight", label: "Weight", placeholder: "e.g. 1.2kg, Short Handle", span: 2 },
  ],
  Football: [
    { key: "brand", label: "Brand", placeholder: "e.g. Nike, Adidas, Nivia", span: 1 },
    { key: "size", label: "Size", placeholder: "e.g. Size 5, Size 4", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Synthetic, Leather", span: 2 },
  ],
  Basketball: [
    { key: "brand", label: "Brand", placeholder: "e.g. Spalding, Molten, Nivia", span: 1 },
    { key: "size", label: "Size", placeholder: "e.g. Size 7, Size 6", span: 2 },
  ],
  "Gym Equipment": [
    { key: "brand", label: "Brand", placeholder: "e.g. Kobo, Lifeline, Boldfit", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Dumbbell, Bench, Mat, Band", span: 1 },
    { key: "weight", label: "Weight", placeholder: "e.g. 5kg, 10kg", span: 2 },
  ],
  Badminton: [
    { key: "brand", label: "Brand", placeholder: "e.g. Yonex, Li-Ning, Victor", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Racket, Shuttlecock, Kit", span: 2 },
  ],
  Cycling: [
    { key: "brand", label: "Brand", placeholder: "e.g. Hero, Firefox, Giant", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Road, Mountain, Hybrid", span: 1 },
    { key: "frame_size", label: "Frame Size", placeholder: "e.g. 26\", 27.5\", 29\"", span: 2 },
  ],
  "Bottle/Flask": [
    { key: "brand", label: "Brand", placeholder: "e.g. Milton, Cello, Nirlon", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Steel, Plastic, Glass, Tritan", span: 1 },
    { key: "capacity", label: "Capacity", placeholder: "e.g. 500ml, 1L, 2L", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Black, Blue, Red", span: 1 },
  ],
  "Sports & Fitness Other": [
    { key: "brand", label: "Brand", placeholder: "e.g. Nike, Adidas, Decathlon", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Equipment, Apparel, Footwear", span: 2 },
  ],

  Notes: [
    { key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths, OS", span: 1 },
    { key: "semester", label: "Semester", placeholder: "e.g. 1st Sem, 1st Class", span: 1 },
    { key: "pages", label: "Pages", placeholder: "e.g. 200, 400", span: 1 },
    { key: "brand", label: "Brand", placeholder: "e.g. Classmate, Classplus", span: 1 },
  ],
  Textbook: [
    { key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 1 },
    { key: "semester", label: "Semester", placeholder: "e.g. 1st Sem, 1st Class", span: 1 },
    { key: "author", label: "Author", placeholder: "e.g. H.C. Verma, R.D. Sharma", span: 1 },
    { key: "edition", label: "Edition", placeholder: "e.g. 3rd Edition 2023", span: 1 },
  ],
  Novel: [
    { key: "author", label: "Author", placeholder: "e.g. Chetan Bhagat, Amish Tripathi", span: 1 },
    { key: "genre", label: "Genre", placeholder: "e.g. Fiction, Thriller, Romance", span: 1 },
    { key: "language", label: "Language", placeholder: "e.g. English, Hindi", span: 1 },
    { key: "semester", label: "Semester", placeholder: "e.g. 1st Sem, 1st Class", span: 1 },
  ],
  Magazine: [
    { key: "genre", label: "Genre", placeholder: "e.g. Tech, Fashion, Sports", span: 1 },
    { key: "language", label: "Language", placeholder: "e.g. English, Hindi", span: 1 },
    { key: "semester", label: "Semester", placeholder: "e.g. 1st Sem, 1st Class", span: 1 },
  ],
  "Books & Notes Other": [
    { key: "subject", label: "Subject", placeholder: "e.g. Physics, Maths", span: 1 },
    { key: "semester", label: "Semester", placeholder: "e.g. 1st Sem, 1st Class", span: 2 },
  ],
  "Art Supplies": [
    { key: "brand", label: "Brand", placeholder: "e.g. Camlin, Faber-Castell", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Paint, Brush, Sketchbook, Crayons", span: 2 },
  ],
  "Geometry Box": [
    { key: "brand", label: "Brand", placeholder: "e.g. Camlin, Doms, Maped", span: 2 },
  ],
  "Stationery Other": [
    { key: "brand", label: "Brand", placeholder: "e.g. Classmate, Natraj", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Notebook, Pen set", span: 2 },
  ],

  Fan: [
    { key: "brand", label: "Brand", placeholder: "e.g. Havells, Crompton, Orient", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Ceiling, Table, Pedestal", span: 1 },
    { key: "power", label: "Power", placeholder: "e.g. 40W, 75W", span: 2 },
  ],
  Fridge: [
    { key: "brand", label: "Brand", placeholder: "e.g. Samsung, LG, Whirlpool", span: 1 },
    { key: "capacity", label: "Capacity", placeholder: "e.g. 200L, 300L", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Single Door, Double Door", span: 2 },
  ],
  Microwave: [
    { key: "brand", label: "Brand", placeholder: "e.g. Samsung, LG, IFB", span: 1 },
    { key: "capacity", label: "Capacity", placeholder: "e.g. 20L, 28L", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Solo, Convection, Grill", span: 2 },
  ],
  "Washing Machine": [
    { key: "brand", label: "Brand", placeholder: "e.g. Samsung, LG, IFB", span: 1 },
    { key: "capacity", label: "Capacity", placeholder: "e.g. 6kg, 8kg", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Front Load, Top Load, Semi-Auto", span: 2 },
  ],
  AC: [
    { key: "brand", label: "Brand", placeholder: "e.g. Samsung, LG, Voltas", span: 1 },
    { key: "capacity", label: "Capacity", placeholder: "e.g. 1 Ton, 1.5 Ton", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Split, Window, Inverter", span: 2 },
  ],
  Heater: [
    { key: "brand", label: "Brand", placeholder: "e.g. Bajaj, Havells, Morphy Richards", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Room Heater, Geyser, Immersion Rod", span: 2 },
  ],
  "Appliances Other": [
    { key: "brand", label: "Brand", placeholder: "e.g. Philips, Bajaj, Prestige", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Mixer, Iron, Vacuum", span: 2 },
  ],

  "Board Game": [
    { key: "brand", label: "Brand", placeholder: "e.g. Hasbro, Funskool, Mattel", span: 1 },
    { key: "players", label: "Players", placeholder: "e.g. 2-4, 4-8", span: 1 },
    { key: "play_time", label: "Play Time", placeholder: "e.g. 30 min, 1-2 hrs", span: 2 },
  ],
  "Video Game": [
    { key: "platform", label: "Platform", placeholder: "e.g. PS5, PC, Switch, Mobile", span: 1 },
    { key: "genre", label: "Genre", placeholder: "e.g. Action, RPG, Sports", span: 1 },
    { key: "edition", label: "Edition", placeholder: "e.g. Standard, GOTY, Deluxe", span: 2 },
  ],
  Puzzle: [
    { key: "pieces", label: "Pieces", placeholder: "e.g. 100, 500, 1000", span: 1 },
    { key: "brand", label: "Brand", placeholder: "e.g. Ravensburger, Funskool", span: 1 },
    { key: "age_group", label: "Age Group", placeholder: "e.g. 6+, 12+, All Ages", span: 2 },
  ],
  Instrument: [
    { key: "brand", label: "Brand", placeholder: "e.g. Yamaha, Casio, Fender", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Guitar, Keyboard, Violin", span: 1 },
    { key: "condition", label: "Condition Notes", placeholder: "e.g. Tuned, Strung, Ready to play", span: 2 },
  ],
  Collectible: [
    { key: "brand", label: "Brand", placeholder: "e.g. Funko, Marvel, Bandai", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Figure, Card, Comic", span: 2 },
  ],
  "Games Other": [
    { key: "brand", label: "Brand", placeholder: "e.g. Sony, Nintendo, Hasbro", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Board Game, Video Game, Collectible", span: 2 },
  ],

  Homemade: [
    { key: "diet", label: "Diet", placeholder: "e.g. Vegetarian, Non-Veg, Vegan", span: 1 },
    { key: "cuisine", label: "Cuisine", placeholder: "e.g. North Indian, South Indian, Chinese", span: 1 },
    { key: "servings", label: "Servings", placeholder: "e.g. 1, 2, 4", span: 2 },
  ],
  Packaged: [
    { key: "brand", label: "Brand", placeholder: "e.g. Haldiram's, Bikano, Patanjali", span: 1 },
    { key: "diet", label: "Diet", placeholder: "e.g. Vegetarian, Non-Veg", span: 1 },
    { key: "contains", label: "Contains", placeholder: "e.g. Nuts, Dairy, Gluten", span: 2 },
  ],
  Beverages: [
    { key: "type", label: "Type", placeholder: "e.g. Juice, Soda, Tea, Coffee", span: 1 },
    { key: "brand", label: "Brand", placeholder: "e.g. Real, Paper Boat, Nescafe", span: 1 },
    { key: "volume", label: "Volume", placeholder: "e.g. 250ml, 1L", span: 2 },
  ],
  Snacks: [
    { key: "brand", label: "Brand", placeholder: "e.g. Haldiram's, Kurkure, Lays", span: 1 },
    { key: "diet", label: "Diet", placeholder: "e.g. Vegetarian, Non-Veg", span: 1 },
    { key: "contains", label: "Contains", placeholder: "e.g. Nuts, Gluten, Soy", span: 2 },
  ],
  "Food & Drinks Other": [
    { key: "diet", label: "Diet", placeholder: "e.g. Vegetarian, Non-Veg, Vegan", span: 1 },
    { key: "contains", label: "Contains", placeholder: "e.g. Nuts, Dairy, Gluten", span: 2 },
  ],

  Backpack: [
    { key: "brand", label: "Brand", placeholder: "e.g. Wildcraft, American Tourister, Skybags", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Polyester, Nylon, Canvas", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Black, Blue, Grey", span: 1 },
    { key: "capacity", label: "Capacity", placeholder: "e.g. 20L, 30L, 40L", span: 1 },
  ],
  "Laptop Bag": [
    { key: "brand", label: "Brand", placeholder: "e.g. Targus, Samsonite, Amazon Basics", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Polyester, Nylon, Leather", span: 1 },
    { key: "laptop_size", label: "Laptop Size", placeholder: "e.g. 13\", 14\", 15.6\"", span: 2 },
  ],
  "Duffel Bag": [
    { key: "brand", label: "Brand", placeholder: "e.g. Adidas, Nike, Puma", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Polyester, Nylon", span: 1 },
    { key: "capacity", label: "Capacity", placeholder: "e.g. 40L, 60L, 80L", span: 2 },
  ],
  "Messenger Bag": [
    { key: "brand", label: "Brand", placeholder: "e.g. Hidesign, Wildcraft", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Canvas, Leather, Nylon", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Brown, Black, Olive", span: 2 },
  ],
  Tote: [
    { key: "brand", label: "Brand", placeholder: "e.g. H&M, Zara, local brand", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Canvas, Leather, Cotton", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Black, Beige, Blue", span: 2 },
  ],
  "Travel Bag": [
    { key: "brand", label: "Brand", placeholder: "e.g. Samsonite, American Tourister, Safari", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Polycarbonate, Polyester, Hard Shell", span: 1 },
    { key: "capacity", label: "Capacity", placeholder: "e.g. 50L, 70L, 90L", span: 1 },
    { key: "size", label: "Size Type", placeholder: "e.g. Cabin, Check-in, Large", span: 2 },
  ],
  Wallet: [
    { key: "brand", label: "Brand", placeholder: "e.g. Wildcraft, Hidesign, Nappa Dori", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Leather, Canvas, Synthetic", span: 1 },
    { key: "type", label: "Type", placeholder: "e.g. Bi-fold, Tri-fold, Card Holder, Minimalist", span: 2 },
  ],
  "Bags Other": [
    { key: "brand", label: "Brand", placeholder: "e.g. Wildcraft, Skybags, Tommy", span: 1 },
    { key: "material", label: "Material", placeholder: "e.g. Polyester, Nylon, Leather", span: 1 },
    { key: "color", label: "Color", placeholder: "e.g. Black, Blue, Grey", span: 2 },
  ],
};

const _specSuggestionsMap = {
  Laptop: {
    brand: ["Apple", "Dell", "HP", "Lenovo", "Samsung", "Sony", "Asus", "Acer", "Microsoft", "LG", "OnePlus", "Xiaomi"],
    ram: ["2GB", "4GB", "6GB", "8GB", "12GB", "16GB", "32GB", "64GB"],
    storage: ["64GB", "128GB", "256GB", "512GB", "1TB", "2TB"],
    processor: ["Intel i3", "Intel i5", "Intel i7", "Intel i9", "AMD Ryzen 5", "AMD Ryzen 7", "Apple M1", "Apple M2", "Apple M3", "Snapdragon"],
    display: ['11"', '13"', '14"', '15.6"', '16"', "Full HD", "4K", "OLED", "Retina Display"],
  },
  Phone: {
    brand: ["Samsung", "Apple", "OnePlus", "Xiaomi", "Realme", "Vivo", "Oppo", "Nothing", "Google", "Motorola"],
    ram: ["3GB", "4GB", "6GB", "8GB", "12GB", "16GB"],
    storage: ["32GB", "64GB", "128GB", "256GB", "512GB", "1TB"],
    battery: ["3000mAh", "4000mAh", "5000mAh", "6000mAh"],
    display: ['5.8"', '6.1"', '6.4"', '6.5"', '6.7"', "AMOLED", "IPS LCD", "OLED"],
  },
  Tablet: {
    brand: ["Apple", "Samsung", "Lenovo", "OnePlus", "Xiaomi", "Realme"],
    ram: ["2GB", "3GB", "4GB", "6GB", "8GB"],
    storage: ["32GB", "64GB", "128GB", "256GB", "512GB"],
    display: ['8"', '10.2"', '10.9"', '11"', "Retina", "AMOLED"],
  },
  Headphones: {
    brand: ["Sony", "JBL", "Boat", "Sennheiser", "Audio-Technica", "Marshall", "OnePlus", "Realme"],
    type: ["Over-ear", "On-ear", "In-ear", "Earbuds", "Neckband"],
    battery: ["Wired", "10hrs", "20hrs", "30hrs", "40hrs"],
  },
  Camera: {
    brand: ["Canon", "Nikon", "Sony", "Fujifilm", "Panasonic", "GoPro", "DJI"],
    type: ["DSLR", "Mirrorless", "Point-and-shoot", "Action Camera", "Instant"],
    megapixels: ["12MP", "20MP", "24MP", "26MP", "45MP", "61MP"],
  },
  "Electronics Accessories": {
    brand: ["Portronics", "Ambrane", "Boat", "Zebronics", "pTron", "Baseus", "Spigen"],
    type: ["Case", "Charger", "Cable", "Stand", "Screen Protector", "Power Bank", "Mouse", "Keyboard"],
  },

  Clothing: {
    gender: ["Male", "Female", "Unisex", "Kids"],
    color: ["Black", "White", "Navy Blue", "Grey", "Red", "Green", "Brown", "Beige", "Multicolor"],
    type: ["T-shirt", "Shirt", "Jeans", "Trousers", "Jacket", "Hoodie", "Kurta", "Saree", "Shorts", "Dress", "Sweater"],
  },

  Chair: {
    material: ["Wood", "Solid Wood", "Metal", "Plastic", "Mesh", "Leather", "Fabric"],
    color: ["Brown", "Black", "White", "Grey", "Blue", "Red"],
    dimensions: ["Compact", "Standard", "Recliner", "Office Chair", "Dining Chair"],
  },
  Table: {
    material: ["Solid Wood", "Engineered Wood", "Glass", "Metal", "Marble", "Plastic"],
    color: ["Brown", "White", "Black", "Natural Wood", "Walnut"],
    dimensions: ["Small (4-seater)", "Medium (6-seater)", "Large (8-seater)", "Coffee Table", "Study Table"],
  },
  Bed: {
    material: ["Solid Wood", "Engineered Wood", "Metal", "Upholstered"],
    size: ["Single", "Double", "Queen", "King"],
    color: ["Brown", "White", "Black", "Natural Wood", "Grey"],
  },
  Shelf: {
    material: ["Wood", "Metal", "Plastic", "Glass"],
    color: ["Brown", "White", "Black", "Natural Wood"],
  },
  Sofa: {
    material: ["Fabric", "Leather", "Velvet", "Linen", "Faux Leather"],
    color: ["Grey", "Blue", "Beige", "Brown", "Black", "Green"],
    dimensions: ["2-Seater", "3-Seater", "L-Shaped", "Sectional"],
  },
  "Furniture Other": {
    material: ["Wood", "Metal", "Plastic", "Glass"],
    color: ["Brown", "White", "Black", "Natural Wood"],
  },

  Cricket: {
    brand: ["SG", "MRF", "SS", "GM", "Kookaburra", "Gray-Nicolls"],
    type: ["Bat", "Ball", "Pads", "Gloves", "Helmet", "Kit Bag"],
    weight: ["Short Handle", "Long Handle", "Junior", "Senior", "Incrediball"],
  },
  Football: {
    brand: ["Nike", "Adidas", "Puma", "Nivia", "Cosco", "Vector X"],
    size: ["Size 3", "Size 4", "Size 5"],
    material: ["Synthetic", "Leather", "Rubber"],
  },
  Basketball: {
    brand: ["Spalding", "Molten", "Nivia", "Cosco", "Vector X"],
    size: ["Size 5", "Size 6", "Size 7"],
  },
  "Gym Equipment": {
    brand: ["Kobo", "Lifeline", "Boldfit", "Fitbox", "Powertrain", "Decathlon"],
    type: ["Dumbbell", "Barbell", "Bench", "Mat", "Resistance Band", "Kettlebell", "Pull-up Bar"],
    weight: ["1kg", "2kg", "5kg", "7.5kg", "10kg", "15kg", "20kg"],
  },
  Badminton: {
    brand: ["Yonex", "Li-Ning", "Victor", "Babolat", "Cosco"],
    type: ["Racket", "Shuttlecock", "Kit Bag", "Net", "Shoes"],
  },
  Cycling: {
    brand: ["Hero", "Firefox", "Giant", "Trek", "BTWIN", "Mach City", "Montra"],
    type: ["Road", "Mountain", "Hybrid", "Folding", "Electric"],
    frame_size: ['24"', '26"', '27.5"', '29"', "XS", "S", "M", "L", "XL"],
  },
  "Bottle/Flask": {
    brand: ["Milton", "Cello", "Nirlon", "Borosil", "Signoraware", "Tupperware", "Prestige", "Milton Thermosteel"],
    material: ["Stainless Steel", "Plastic", "Glass", "Tritan", "Aluminium", "Copper"],
    capacity: ["250ml", "500ml", "750ml", "1L", "1.5L", "2L"],
    color: ["Black", "Blue", "Red", "Green", "Pink", "White", "Grey"],
  },
  "Sports & Fitness Other": {
    brand: ["Nike", "Adidas", "Puma", "Decathlon", "Yonex", "Nivia"],
    type: ["Equipment", "Apparel", "Footwear", "Accessory"],
  },

  Notes: {
    subject: ["Physics", "Chemistry", "Mathematics", "Biology", "English", "Computer Science", "Economics", "History", "Geography"],
    semester: ["1st Sem", "2nd Sem", "3rd Sem", "4th Sem", "5th Sem", "6th Sem", "7th Sem", "8th Sem", "1st Class", "2nd Class", "3rd Class", "4th Class", "5th Class", "6th Class", "7th Class", "8th Class", "9th Class", "10th Class", "11th Class", "12th Class"],
    pages: ["50", "100", "200", "300", "400", "500"],
    brand: ["Classmate", "Classplus", "Buzz", "Navneet", "Spiral", "Unbranded"],
  },
  Textbook: {
    subject: ["Physics", "Chemistry", "Mathematics", "Biology", "English", "Computer Science", "Economics", "History", "Geography"],
    semester: ["1st Sem", "2nd Sem", "3rd Sem", "4th Sem", "5th Sem", "6th Sem", "7th Sem", "8th Sem", "1st Class", "2nd Class", "3rd Class", "4th Class", "5th Class", "6th Class", "7th Class", "8th Class", "9th Class", "10th Class", "11th Class", "12th Class"],
    author: ["H.C. Verma", "R.D. Sharma", "S.L. Arora", "NCERT", "Arihant", "DC Pandey", "P.K. Nag"],
    edition: ["1st Edition", "2nd Edition", "3rd Edition", "4th Edition", "2022 Edition", "2023 Edition", "2024 Edition", "Latest Edition"],
  },
  Novel: {
    author: ["Chetan Bhagat", "Amish Tripathi", "Arundhati Roy", "Salman Rushdie", "Ruskin Bond", "Sudha Murty", "Devdutt Pattanaik"],
    genre: ["Fiction", "Non-Fiction", "Thriller", "Romance", "Sci-Fi", "Fantasy", "Mystery", "Horror", "Self-Help", "Biography"],
    language: ["English", "Hindi", "Tamil", "Bengali", "Marathi", "Telugu", "Kannada", "Malayalam"],
    semester: ["1st Sem", "2nd Sem", "3rd Sem", "4th Sem", "5th Sem", "6th Sem", "7th Sem", "8th Sem", "1st Class", "2nd Class", "3rd Class", "4th Class", "5th Class", "6th Class", "7th Class", "8th Class", "9th Class", "10th Class", "11th Class", "12th Class"],
  },
  "Art Supplies": {
    brand: ["Camlin", "Faber-Castell", "Doms", "Staedtler", "Fevicryl", "Mont Marte", "Brustro"],
    type: ["Watercolor", "Acrylic Paint", "Oil Paint", "Sketch Pens", "Brushes", "Sketchbook", "Canvas", "Crayons", "Pastels", "Palette"],
  },
  "Geometry Box": {
    brand: ["Camlin", "Doms", "Maped", "Classmate", "Faber-Castell"],
  },
  "Stationery Other": {
    brand: ["Classmate", "Natraj", "Camlin", "Reynolds", "Cello", "Faber-Castell", "Staedtler", "Casio"],
    type: ["Notebook", "Pen Set", "Pencil Set", "Marker Set", "Highlighters", "Sticky Notes", "Calculator", "Art Kit"],
  },

  Fan: {
    brand: ["Havells", "Crompton", "Orient", "Bajaj", "Anchor", "Syska"],
    type: ["Ceiling", "Table", "Pedestal", "Wall Mount", "Exhaust"],
    power: ["25W", "40W", "50W", "75W", "100W"],
  },
  Fridge: {
    brand: ["Samsung", "LG", "Whirlpool", "Haier", "Godrej", "Voltas", "IFB", "Bosch"],
    capacity: ["150L", "200L", "250L", "300L", "350L", "400L", "500L"],
    type: ["Single Door", "Double Door", "Side by Side", "French Door"],
  },
  Microwave: {
    brand: ["Samsung", "LG", "IFB", "Bajaj", "Morphy Richards", "Whirlpool", "Panasonic"],
    capacity: ["17L", "20L", "23L", "25L", "28L", "30L"],
    type: ["Solo", "Convection", "Grill", "Microwave+Grill", "Microwave+Convection"],
  },
  "Washing Machine": {
    brand: ["Samsung", "LG", "IFB", "Whirlpool", "Bosch", "Haier", "Godrej"],
    capacity: ["5.5kg", "6kg", "6.5kg", "7kg", "7.5kg", "8kg", "9kg"],
    type: ["Front Load", "Top Load", "Semi-Auto", "Fully-Auto"],
  },
  AC: {
    brand: ["Samsung", "LG", "Voltas", "Daikin", "Blue Star", "Hitachi", "Carrier", "Panasonic"],
    capacity: ["0.75 Ton", "1 Ton", "1.5 Ton", "2 Ton"],
    type: ["Split", "Window", "Inverter", "Portable"],
  },
  Heater: {
    brand: ["Bajaj", "Havells", "Morphy Richards", "Crompton", "Orient", "V-Guard"],
    type: ["Room Heater", "Water Heater", "Geyser", "Immersion Rod", "Oil Filled Radiator"],
  },
  "Appliances Other": {
    brand: ["Philips", "Bajaj", "Prestige", "Pigeon", "Butterfly", "Preethi", "Havells"],
    type: ["Mixer Grinder", "Iron", "Vacuum Cleaner", "Air Purifier", "Water Purifier", "Toaster"],
  },

  "Board Game": {
    brand: ["Hasbro", "Funskool", "Mattel", "Milton Bradley", "Parker Brothers", "Winning Moves"],
    players: ["1-2", "2-4", "3-6", "4-8", "6+"],
    play_time: ["15 min", "30 min", "45 min", "1-2 hrs", "2+ hrs"],
  },
  "Video Game": {
    platform: ["PS4", "PS5", "Xbox One", "Xbox Series X", "PC", "Nintendo Switch", "Mobile", "Steam Deck"],
    genre: ["Action", "Strategy", "RPG", "Sports", "Racing", "Puzzle", "Adventure", "Simulation", "FPS", "Horror", "Fighting"],
    edition: ["Standard", "Deluxe", "GOTY", "Ultimate", "Collector's"],
  },
  Puzzle: {
    pieces: ["50", "100", "250", "500", "1000", "2000", "5000"],
    brand: ["Ravensburger", "Funskool", "Buffalo Games", "Schmidt", "CubicFun"],
    age_group: ["3+", "6+", "8+", "10+", "12+", "14+", "All Ages"],
  },
  Instrument: {
    brand: ["Yamaha", "Casio", "Fender", "Gibson", "Ibanez", "Cort", "Hofner", "Kala"],
    type: ["Guitar", "Keyboard", "Violin", "Flute", "Ukulele", "Drums", "Harmonium", "Sitar", "Tabla"],
    condition: ["Tuned", "New Strings", "Ready to Play", "Needs Setup", "Well-Maintained"],
  },
  Collectible: {
    brand: ["Funko", "Marvel", "DC", "Bandai", "Hot Toys", "McFarlane", "NECA", "Good Smile"],
    type: ["Action Figure", "Funko Pop", "Trading Card", "Comic Book", "Statue", "Model Kit"],
  },
  "Games Other": {
    brand: ["Sony", "Microsoft", "Nintendo", "Hasbro", "Funskool", "Mattel"],
    type: ["Board Game", "Video Game", "Card Game", "Puzzle", "Collectible", "Toy"],
  },

  Homemade: {
    diet: ["Vegetarian", "Non-Vegetarian", "Vegan", "Jain", "Gluten-Free"],
    cuisine: ["North Indian", "South Indian", "Chinese", "Italian", "Mughlai", "Bengali", "Gujarati", "Rajasthani", "Continental"],
    servings: ["1", "2", "3-4", "5+"],
  },
  Packaged: {
    brand: ["Haldiram's", "Bikano", "Patanjali", "MDH", "Everest", "ITC", "Britannia", "Parle"],
    diet: ["Vegetarian", "Non-Vegetarian", "Vegan", "Gluten-Free"],
    contains: ["No Allergens", "Nuts", "Dairy", "Gluten", "Soy", "Eggs"],
  },
  Beverages: {
    type: ["Juice", "Soda", "Tea", "Coffee", "Energy Drink", "Lassi", "Shake", "Smoothie"],
    brand: ["Real", "Paper Boat", "Bisleri", "Frooti", "Nescafe", "Bru", "Red Bull", "Sting"],
    volume: ["200ml", "250ml", "500ml", "1L", "1.5L", "2L"],
  },
  Snacks: {
    brand: ["Haldiram's", "Kurkure", "Lays", "Bingo", "Act II", "Pringles", "Kettle Brand", "Too Yumm"],
    diet: ["Vegetarian", "Non-Vegetarian", "Vegan"],
    contains: ["No Allergens", "Nuts", "Dairy", "Gluten", "Soy"],
  },
  "Food & Drinks Other": {
    diet: ["Vegetarian", "Non-Vegetarian", "Vegan", "Gluten-Free"],
    contains: ["No Allergens", "Nuts", "Dairy", "Gluten", "Soy", "Eggs"],
  },

  Backpack: {
    brand: ["Wildcraft", "American Tourister", "Skybags", "Safari", "Plastic", "Decathlon", "Puma", "Nike"],
    material: ["Polyester", "Nylon", "Canvas", "Ripstop", "Cordura"],
    color: ["Black", "Blue", "Grey", "Red", "Green", "Navy", "Maroon"],
    capacity: ["15L", "20L", "25L", "30L", "35L", "40L", "50L"],
  },
  "Laptop Bag": {
    brand: ["Targus", "Samsonite", "Amazon Basics", "Lenovo", "HP", "Dell", "Wildcraft"],
    material: ["Polyester", "Nylon", "Leather", "Neoprene"],
    laptop_size: ['11"', '12.5"', '13.3"', '14"', '15.6"', '16"', '17"'],
  },
  "Duffel Bag": {
    brand: ["Adidas", "Nike", "Puma", "Decathlon", "Wildcraft", "Skybags"],
    material: ["Polyester", "Nylon", "Canvas"],
    capacity: ["30L", "40L", "50L", "60L", "80L", "100L"],
  },
  "Messenger Bag": {
    brand: ["Hidesign", "Wildcraft", "Skybags", "Tommy", "Fossil", "Lavie"],
    material: ["Canvas", "Leather", "Nylon", "Polyester"],
    color: ["Brown", "Black", "Olive", "Tan", "Navy"],
  },
  Tote: {
    brand: ["H&M", "Zara", "Mango", "Lavie", "Hidesign", "Fabindia"],
    material: ["Canvas", "Leather", "Cotton", "Nylon", "Jute"],
    color: ["Black", "Beige", "Blue", "White", "Pink", "Grey"],
  },
  "Travel Bag": {
    brand: ["Samsonite", "American Tourister", "Safari", "Skybags", "Delsey", "Wildcraft"],
    material: ["Polycarbonate", "ABS", "Polyester", "Nylon", "Hard Shell", "Soft Shell"],
    capacity: ["40L", "50L", "60L", "70L", "80L", "100L+"],
    size: ["Cabin (55cm)", "Medium (68cm)", "Large (78cm)", "Check-in"],
  },
  Wallet: {
    brand: ["Wildcraft", "Hidesign", "Nappa Dori", "Tommy", "Fossil", "Woodland"],
    material: ["Leather", "Faux Leather", "Canvas", "Nylon", "Fabric"],
    type: ["Bi-fold", "Tri-fold", "Card Holder", "Money Clip", "Minimalist", "Long Wallet"],
  },
  "Bags Other": {
    brand: ["Wildcraft", "Skybags", "Tommy", "Hidesign", "Safari", "Decathlon"],
    material: ["Polyester", "Nylon", "Canvas", "Leather"],
    color: ["Black", "Blue", "Grey", "Brown", "Red"],
  },
};

const _specValidators = {
  Laptop: {
    brand: (v) => _badStart(v) || (_pureNum(v) ? "Enter a brand name" : v.length < 2 ? "Too short" : null),
    ram: (v) => _badStart(v) || (!/^\d+\s*(gb|tb|mb)/i.test(v.trim()) ? "e.g. 8GB, 16GB" : null),
    storage: (v) => _badStart(v) || (!/^\d+\s*(gb|tb|mb)/i.test(v.trim()) ? "e.g. 256GB, 1TB" : null),
    processor: (v) => _badStart(v) || (_pureNum(v) ? "Enter processor name" : v.length < 2 ? "Too short" : null),
    display: (v) => _badStart(v) || (_pureNum(v) ? 'e.g. 15.6", 4K OLED' : null),
  },
  Phone: {
    brand: (v) => _badStart(v) || (_pureNum(v) ? "Enter a brand name" : v.length < 2 ? "Too short" : null),
    ram: (v) => _badStart(v) || (!/^\d+\s*(gb|tb|mb)/i.test(v.trim()) ? "e.g. 8GB, 12GB" : null),
    storage: (v) => _badStart(v) || (!/^\d+\s*(gb|tb|mb)/i.test(v.trim()) ? "e.g. 128GB, 256GB" : null),
    battery: (v) => _badStart(v) || (!/^\d+\s*(mah|hrs?)/i.test(v.trim()) ? "e.g. 5000mAh, 24hrs" : null),
    display: (v) => _badStart(v) || (_pureNum(v) ? 'e.g. 6.5", AMOLED' : null),
  },
  Tablet: {
    brand: (v) => _badStart(v) || (_pureNum(v) ? "Enter a brand name" : v.length < 2 ? "Too short" : null),
    ram: (v) => _badStart(v) || (!/^\d+\s*(gb|tb|mb)/i.test(v.trim()) ? "e.g. 4GB, 8GB" : null),
    storage: (v) => _badStart(v) || (!/^\d+\s*(gb|tb|mb)/i.test(v.trim()) ? "e.g. 64GB, 256GB" : null),
    display: (v) => _badStart(v) || (_pureNum(v) ? 'e.g. 10.9", Retina' : null),
  },
  Clothing: {
    gender: (v) => _badStart(v) || (!/[a-zA-Z]/.test(v) ? "Enter gender — e.g. Male, Female" : null),
    color: (v) => _badStart(v) || (_pureNum(v) ? "Enter a color name" : v.length < 4 ? "Too short" : null),
    type: (v) => _badStart(v) || (_pureNum(v) ? "Enter clothing type" : v.length < 4 ? "Too short" : null),
  },
};

const _noLetters = (v) => !/[a-zA-Z]/.test(v);
const _pureNum = (v) => /^\d+$/.test(v.trim());
const _startsSpecial = (v) => /^[^a-zA-Z0-9]/.test(v.trim());
const _badStart = (v) => _startsSpecial(v) ? "Can't start with a special character" : null;

function _genericBrand(v) { return _badStart(v) || (_pureNum(v) ? "Enter a brand name" : v.length < 2 ? "Too short" : null); }
function _genericType(v) { return _badStart(v) || (_pureNum(v) ? "Enter type" : v.length < 2 ? "Too short" : null); }
function _genericColor(v) { return _badStart(v) || (_pureNum(v) ? "Enter a color name" : v.length < 2 ? "Too short" : null); }
function _genericMaterial(v) { return _badStart(v) || (_pureNum(v) ? "Enter material name" : v.length < 2 ? "Too short" : null); }
function _genericSubject(v) { return _badStart(v) || (_pureNum(v) ? "Enter subject name" : v.length < 3 ? "Too short" : null); }
function _genericAuthor(v) { return _badStart(v) || (_pureNum(v) ? "Enter author name" : v.length < 2 ? "Too short" : null); }

const _sharedValidators = {
  brand: _genericBrand,
  type: _genericType,
  color: _genericColor,
  material: _genericMaterial,
  subject: _genericSubject,
  author: _genericAuthor,
  edition: (v) => _badStart(v) || (v.length < 3 ? "Too short" : null),
  mode: (v) => _badStart(v) || (v.length < 2 ? "Too short" : null),
  experience: (v) => _badStart(v) || (v.length < 2 ? "Too short" : null),
  diet: (v) => _badStart(v) || (!/[a-zA-Z]/.test(v) ? "e.g. Vegetarian, Vegan" : v.length < 2 ? "Too short" : null),
  contains: (v) => _badStart(v) || (!/[a-zA-Z]/.test(v) ? "e.g. Nuts, Dairy" : v.length < 2 ? "Too short" : null),
  capacity: (v) => _badStart(v) || (!/^\d+\s*(l|ltr|litre|kg|kgs|g|ml|w|kw|ton|l)/i.test(v.trim()) ? "e.g. 5kg, 200L, 1.5 Ton" : null),
  power: (v) => _badStart(v) || (!/^\d+\s*(w|kw)/i.test(v.trim()) ? "e.g. 40W, 1000W" : null),
  size: (v) => _badStart(v) || (v.length < 2 ? "Too short" : null),
  weight: (v) => _badStart(v) || (!/^\d+\s*(kg|g|lbs|oz)/i.test(v.trim()) ? "e.g. 1.2kg, 200g" : null),
  pages: (v) => _badStart(v) || (!_pureNum(v) ? "Enter page count" : null),
  language: (v) => _badStart(v) || (_pureNum(v) ? "Enter language" : v.length < 2 ? "Too short" : null),
  genre: (v) => _badStart(v) || (_pureNum(v) ? "Enter genre" : v.length < 2 ? "Too short" : null),
  platform: (v) => _badStart(v) || (_pureNum(v) ? "e.g. PS5, PC, Switch" : null),
  players: (v) => _badStart(v) || (!/\d/.test(v) ? "e.g. 2-4, 4-8" : null),
  play_time: (v) => _badStart(v) || (!/\d/.test(v) ? "e.g. 30 min, 1-2 hrs" : null),
  pieces: (v) => _badStart(v) || (!_pureNum(v) ? "Enter number of pieces" : null),
  age_group: (v) => _badStart(v) || (!/\d/.test(v) ? "e.g. 6+, 12+" : null),
  servings: (v) => _badStart(v) || (!_pureNum(v) ? "Enter number of servings" : null),
  cuisine: (v) => _badStart(v) || (_pureNum(v) ? "Enter cuisine" : v.length < 2 ? "Too short" : null),
  volume: (v) => _badStart(v) || (!/^\d+\s*(ml|l|ltr|cl)/i.test(v.trim()) ? "e.g. 250ml, 1L" : null),
  dimensions: (v) => _badStart(v) || (_pureNum(v) ? "Add a unit — e.g. 120×60 cm" : null),
  laptop_size: (v) => _badStart(v) || (!/^\d/.test(v) ? 'e.g. 14", 15.6"' : null),
  frame_size: (v) => _badStart(v) || (v.length < 2 ? "Too short" : null),
  megapixels: (v) => _badStart(v) || (!/^\d+\s*(mp|megapixel)/i.test(v.trim()) ? "e.g. 24MP, 45MP" : null),
  battery: (v) => _badStart(v) || (!/^\d+\s*(mah|hrs?)/i.test(v.trim()) ? "e.g. 5000mAh, 24hrs" : null),
  noise_cancelling: (v) => _badStart(v) || (v.length < 2 ? "Too short" : null),
};

function _getValidatorsForSubcategory(subcategory) {
  const fields = _specFieldsMap[subcategory] || [];
  const validators = {};
  for (const f of fields) {
    if (_specValidators[subcategory]?.[f.key]) {
      validators[f.key] = _specValidators[subcategory][f.key];
    } else if (_sharedValidators[f.key]) {
      validators[f.key] = _sharedValidators[f.key];
    }
  }
  return validators;
}

export const specFieldsMap = _specFieldsMap;
export const specSuggestionsMap = _specSuggestionsMap;

export function getSpecFields(category, subcategory, institutionType) {
  if (subcategory && _specFieldsMap[subcategory]) {
    return _specFieldsMap[subcategory].map(f =>
      f.key === "semester" ? { ...f, label: institutionType === "school" ? "Class" : "Semester" } : f
    );
  }
  const subs = subcategoryMap[category] || [];
  const allFields = [];
  const seen = new Set();
  for (const sub of subs) {
    for (const f of (_specFieldsMap[sub] || [])) {
      const field = f.key === "semester" ? { ...f, label: institutionType === "school" ? "Class" : "Semester" } : f;
      if (!seen.has(f.key)) {
        seen.add(f.key);
        allFields.push(field);
      }
    }
  }
  return allFields;
}

export function getSpecSuggestions(category, subcategory, fieldKey) {
  if (subcategory && _specSuggestionsMap[subcategory]?.[fieldKey]) {
    return _specSuggestionsMap[subcategory][fieldKey];
  }
  const subs = subcategoryMap[category] || [];
  const allSuggestions = [];
  const seen = new Set();
  for (const sub of subs) {
    for (const s of (_specSuggestionsMap[sub]?.[fieldKey] || [])) {
      if (!seen.has(s)) {
        seen.add(s);
        allSuggestions.push(s);
      }
    }
  }
  return allSuggestions;
}

export function getSpecValidators(category, subcategory) {
  if (subcategory && _specValidators[subcategory]) {
    return _specValidators[subcategory];
  }
  const validators = {};
  const fields = getSpecFields(category, subcategory);
  for (const f of fields) {
    if (_sharedValidators[f.key]) {
      validators[f.key] = _sharedValidators[f.key];
    }
  }
  return validators;
}

export function getSpecValidator(category, subcategory, fieldKey) {
  if (subcategory && _specValidators[subcategory]?.[fieldKey]) {
    return _specValidators[subcategory][fieldKey];
  }
  return _sharedValidators[fieldKey] || null;
}

export function getSubcategorySpecFields(subcategory) {
  return _specFieldsMap[subcategory] || [];
}
